module.exports = __webpack_public_path__ + "img/HighHat_Average.9eb5948e.jpg";